module.exports = __webpack_public_path__ + "img/AT0000002640835.869c09d5.png";